import { dateDiff, dateFormat } from '@mirai/locale';

import { parseCustomData, sendData } from './helpers';
import { getOccupationTotals } from '../../../../components/helpers';
import { formatPrice } from '../helpers/legacy';

export const checkoutResponse = async ({
  instances = [],
  metaEventId,
  response: { countryCode: country, infantAge, tracking = {} } = {},
  store: { finder: { calendar = [], occupation = [] } = {}, hotel: { id: hotelId } = {} } = {},
} = {}) => {
  // ! -- TODO: use of tracking should be a temporary approach ---------------------------------------------------------
  const {
    hotelInfo: { currency: hotelCurrency = {}, propertyName } = {},
    reservedRooms = [],
    totalPriceWithoutTaxes,
  } = tracking;

  const { days } = dateDiff(...calendar);
  const contents = [];
  const miraiRates = [];
  let numItems = 0;
  reservedRooms.forEach(({ averagePriceWithoutTaxes = 0, numRoomsToReserve = 1, rateId } = {}) => {
    const quantity = days * numRoomsToReserve;

    contents.push({ id: hotelId, itemPrice: formatPrice(averagePriceWithoutTaxes, hotelCurrency), quantity });
    miraiRates.push(rateId);
    numItems += quantity;
  });
  const { adults = 0, babies = 0, children = 0 } = getOccupationTotals({ infantAge, occupation });
  const hasDates = calendar.length === 2;

  const commonData = {
    customData: parseCustomData({
      contentIds: [hotelId].filter(Boolean),
      contents,
      country,
      ...(hasDates
        ? {
            checkinDate: dateFormat(calendar[0], { delimiter: '-', format: 'YYYY-MM-DD' }),
            checkoutDate: dateFormat(calendar[1], { delimiter: '-', format: 'YYYY-MM-DD' }),
          }
        : undefined),
      hotelCurrency,
      miraiRate: miraiRates.length > 1 ? miraiRates : miraiRates[0],
      numItems,
      numAdults: adults,
      numChildren: babies + children,
      propertyName,
      value: formatPrice(totalPriceWithoutTaxes, hotelCurrency),
    }),
    eventName: 'InitiateCheckout',
  };

  const responses = await Promise.all(
    instances.map(({ idTracking, pixelId }) => sendData({ ...commonData, eventId: metaEventId, idTracking, pixelId })),
  ).catch(() => {});

  return responses;
};
